<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] mr-[1px] h-[3px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class=" text-primary-black-01 title-6 md:title-3">Reporte folios</h1>
    </div>
    <mat-form-field appearance="fill" class="w-full mt-5 md:mt-12 md:w-72">
        <mat-label class="px-1">Desde &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Hasta</mat-label>
        <mat-date-range-input [rangePicker]="picker" class="py-[15px] title-9 font-semibold ">
            <input matStartDate placeholder="Fecha inicio" [(ngModel)]="start" #dateRangeStart />
            <input
            matEndDate
            placeholder="Fecha fin"
            [(ngModel)]="end"
            #dateRangeEnd
            (dateChange)="dateRangeChange($event, dateRangeStart, dateRangeEnd)" />
            <!-- <input matStartDate placeholder="Start date" [formControl]="date" >
            <input matEndDate placeholder="End date"  [formControl]="date"> -->
        </mat-date-range-input>

        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <!-- ITEMS MOBILE -->
    <div class="grid grid-cols-1 gap-2 md:hidden sm:grid-cols-2" *ngIf="dataSource">
        <div *ngFor="let item of dataSource"
            class="relative flex flex-col justify-start gap-1 p-4 text-left border-2 border-gray-200 rounded-lg text-primary-black-01">

            <p class="paragraph-4 ">Fecha ingreso: {{ item.fechaIngreso | date: "dd/MM/YYYY"}}</p>

            <p class="paragraph-4">Folio inicial: {{ item.folioInicial }}</p>

            <p class="paragraph-4">Folio final: {{ item.folioFinal }}</p>

            <p class="paragraph-4">Total: {{ item.total }}</p>

            <p class="paragraph-4">Cant. Folios utilizados: {{ item.utilizados }}</p>

            <p class="paragraph-4">Últ. Folio asignado: {{ item.asignados }}</p>

            <p class="paragraph-4">Cant. Folios anulados: {{ item.anulados }}</p>

            <p class="paragraph-4">Fecha vencimiento: {{ item.fechaVencimiento | date: "dd/MM/YYYY"}}</p>

            <div class="flex items-center gap-3">
                <p class="paragraph-4">Estado:</p>
                <div [innerHTML]="printEstadoMobile(item.estado)"></div>
            </div>

        </div>
    </div>

    <!-- TABLE DESKTOP -->
    <app-mat-custom-table class="hidden md:block" (action)="onTableAction($event)" [use_selection]="false"
        [use_detail]="false" [selection]="selection" [dataset]="dataSource" [columns]="columns">
    </app-mat-custom-table>
</main>